import angular from 'angular'

/* @ngInject */
const utils = (
  $window,
  utilsDate,
  utilsMath,
  utilsLimit,
  valueHandler
) => {
  const self = {}

  self.date = utilsDate
  self.limit = utilsLimit
  self.math = utilsMath
  self.forEach = angular.forEach
  self.isObject = angular.isObject
  self.isArray = angular.isArray

  self.copy = (_value) => {
    return angular.copy(_value)
  }

  self.convertToArray = (_object) => {
    const array = []
    for (const key in _object) {
      if (_object.hasOwnProperty(key)) {
        const value = _object[key]
        array.push({
          key: key,
          value: value,
        })
      }
    }
    return array
  }

  self.convertToObject = (_array) => {
    const object = {}
    for (let i = 0; i < _array.length; i++) {
      const element = _array[i]
      object[element.key] = element.value
    }
    return object
  }

  self.addFromArray = (_array, _item) => {
    if (valueHandler.isNotNull(_array) && valueHandler.isNotNull(_item)) {
      _array[_array.length] = _item
    }
  }

  /**
   * Remove an element from an array
   * @param _array The array where the deletion is done
   * @param _id The id of the element we have to remove
   **/
  self.removeFromArray = (_array, _id) => {
    if (valueHandler.isNotNull(_array) && valueHandler.isNotNull(_id)) {
      for (let i = 0, len = _array.length; i < len; i++) {
        if (_array[i].id === _id) {
          _array.splice(i, 1)
          break
        }
      }
    }
  }

  self.emptyArray = (_array) => {
    for (let index = _array.length; index > 0; index--) {
      _array.splice(index - 1, 1)
    }
  }

  self.removeFrom = (_array, _key, _value) => {
    if (valueHandler.isNotNull(_array) && valueHandler.isNotNull(_key)) {
      for (let i = 0, len = _array.length; i < len; i++) {
        if (_array[i][_key] === _value) {
          _array.splice(i, 1)
          break
        }
      }
    }
  }

  /**
   * Update an element from an array
   * @param _array The array where the update is done
   * @param _item The _item we have to update
   **/
  self.updateFromArray = (_array, _item) => {
    if (valueHandler.isArray(_array) && valueHandler.isNotNull(_item)) {
      for (let i = 0, len = _array.length; i < len; i++) {
        if (_array[i].id === _item.id) {
          _array[i] = _item
        }
      }
    }
  }

  self.getElementById = (_array, _id) => {
    if (valueHandler.exists(_array) && valueHandler.exists(_id)) {
      for (let index = 0; index < _array.length; index++) {
        const element = _array[index]
        if (element.id === _id) {
          return element
        }
      }
    }
  }

  /**
   * Update an element from an array
   * @param _array The array where the update is done
   * @param _item The _item we have to update
   **/
  self.isIdInArray = (_array, _id) => {
    if (valueHandler.isNotNull(_array) && valueHandler.isNotNull(_id)) {
      for (let i = 0, len = _array.length; i < len; i++) {
        if (_array[i].id === _id) {
          return true
        }
      }
    }
    return false
  }

  /**
   * Removes html line break (<br />) from a string
   **/
  self.removeHtmlLineBreak = (_string) => {
    if (valueHandler.isNull(_string)) {
      return null
    }
    return _string.replace(/<br\s*[/]?>/g, '')
  }

  self.getBestColRatio = (_length = 10) => {
    let scol = 6
    let mcol = 3
    let lcol = 2

    if (_length < (12 / scol)) {
      scol = Math.ceil((12 / _length))
    }
    if (_length < (12 / mcol)) {
      mcol = Math.ceil((12 / _length))
    }
    if (_length < (12 / lcol)) {
      lcol = Math.ceil((12 / _length))
    }
    return 'col s' + scol + ' m' + mcol + ' l' + lcol
  }

  /**
   * Go to the previous page
   **/
  self.$back = () => {
    window.history.back()
  }

  self.screenSize = $window.innerWidth
  /**
   * Regets size of screen whenever the window is resized
   **/
  angular.element($window).on('resize', () => {
    self.screenSize = $window.innerWidth
  })

  self.getLettersRange = (begin, end) => {
    const letters = []
    const letterFirst = begin
    const letterLast = end
    let letter

    for (letter = letterFirst.charCodeAt(0); letter <= letterLast.charCodeAt(0); letter++) {
      letters.push(String.fromCharCode(letter))
    }

    return letters
  }

  self.mergeObject = (obj1, obj2) => {
    if (obj1 || obj2) {
      self.forEach(obj2, (value, key) => {
        obj1[key] = value
      })
    }
    return obj1
  }

  self.sizeof = (array) => {
    return Object.keys(array).length
  }

  return self
}

export default utils



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/utils/utils.js